import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React, { CSSProperties } from "react";

export function DeleteIcon(props: SvgIconProps) {
  const st0: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 4.1291,
    strokeMiterlimit: 10,
  };
  const st1: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 3.571,
    strokeMiterlimit: 10,
  };
  const st2: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 4.1291,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
  };

  return (
    <SvgIcon {...props} viewBox="0 0 72 72">
      <g>
        <path
          style={st0}
          d="M11.73,24.68V64c0,3.03,2.45,5.48,5.48,5.48h34.68c3.03,0,5.48-2.45,5.48-5.48V24.68H11.73z"
        />
        <path
          style={st0}
          d="M55.98,7.87H13.12c-1.63,0-2.94,1.32-2.94,2.94v6.31h48.74v-6.31C58.92,9.19,57.6,7.87,55.98,7.87z"
        />
        <g>
          <path
            style={st1}
            d="M25.88,5.79c0,0,0-0.86,0-1.92s1.07-1.92,2.38-1.92h3.91c1.31,0,3.45,0,4.76,0h3.91
		c1.31,0,2.38,0.86,2.38,1.92s0,1.92,0,1.92"
          />
        </g>
        <line style={st2} x1="23.67" y1="61.6" x2="23.67" y2="35.21" />
        <line style={st2} x1="34.46" y1="61.6" x2="34.46" y2="35.21" />
        <line style={st2} x1="45.43" y1="61.6" x2="45.43" y2="35.21" />
      </g>
    </SvgIcon>
  );
}
